<template>
	<footer class="app-footer">
		<span><a href="{{companyUrl}}">{{pageTitle}}</a> &copy; 2023 {{company}}</span>
		<span class="ml-auto">Powered by <a href="{{companyUrl}}">{{appTitle}}</a></span>
	</footer>
</template>
<script>
export default {
	name: 'c-footer',
	data: () => {
    	return { 
			appTitle: process.env.APP_TITLE,
			pageTitle: process.env.PAGE_TITLE,
			company: process.env.COMPANY,
			companyUrl: process.env.COMPANY_URL,
		}
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue